import { combineReducers, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { responseTypes, serviceTypes } from "utils/Types";
import { axiosFileUpload, axiosGet } from "../../../utils/APIHelper";

const initialState: any = {
  hasRecommendationAccess: false
};

export const uploadFileAsync = createAsyncThunk(`uploadFile`, async (data: any, thunkApi: any) => {
  const { rejectWithValue } = thunkApi;
  const API_URL = "recommendations";
  const response: any = await axiosFileUpload(API_URL, "recommendation", data);
  if (response.status !== responseTypes.created) {
    return rejectWithValue(response.response.data);
  }
  return response.data;
});

export const getRecommendationAccess = createAsyncThunk("recommendationAccess", async (thunkApi: any) => {
  const API_URL = "uploadaccess";
  const response: any = await axiosGet(API_URL, serviceTypes.recommendation);
  if (response.status !== responseTypes.success) {
    return thunkApi.rejectWithValue(response.data);
  }
  return response.data;
});

export const RecommendationsSlice = createSlice({
  name: "Recommendations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRecommendationAccess.fulfilled, (state, action: any) => {
        state.hasRecommendationAccess = true;
      })
      .addCase(getRecommendationAccess.rejected, (state, action: any) => {
        state.hasRecommendationAccess = false;
      });
  }
});

const rootReducer = combineReducers({
  Recommendations: RecommendationsSlice.reducer
});

export default rootReducer;
